<template>

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{cardTitle}}
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title class="subtitle-1">
                {{description}}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog=false" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <!-- <v-dialog v-model="dialog" scrollable width="800px">
     <v-card>
       <v-card-title class="borderbluebottom">

         <span class="font-weight-thin bluetext headline">Neuen Bogen erstellen</span>
         <v-spacer></v-spacer>

       </v-card-title>
       <v-card-text>
         <v-layout row wrap justify-start>
           <v-flex>
           <span class="font-weight-thin ">
           Hier können Sie einen neuen Bogen erstellen.
             </span>
           </v-flex>
         </v-layout>
         <v-layout row wrap justify-space-around>
           <v-flex md12>
             <v-text-field
               label="Bogenname"
               box
               color="examenis"
               background-color="examenishell"
               v-model="title"
             ></v-text-field>
           </v-flex>
           <v-flex md12 class="bordernone borderone textfieldsmaller pt-4">
             <Subjects v-model="mySubjects"></Subjects>
           </v-flex>
         </v-layout>

       </v-card-text>
       <v-card-actions>
         <v-btn @click="dialog=false" color="examenis" dark large round outline
                class="font-weight-bold radiusBtn text-none">abbrechen
         </v-btn>
         <v-spacer></v-spacer>
         <v-btn @click="createNewItem" color="examenis" dark large round outline
                class="font-weight-bold radiusBtn text-none">Erstellen
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>-->
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'DialogLoginFailed',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.newName = cardConfig.newName
          this.cardTitle = cardConfig.title
          this.type = cardConfig.type
          this.description = cardConfig.description
        }
        this.dialog = true
      }
    },
    data () {
      return {
        cardTitle: 'Login nicht erfolgreich',
        type: 'group',
        pwOld: '',
        pwNew: '',
        pwNew2: '',
        imageLayout: '0',
        questionTyp: '1',
        mySubjects: {},
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false
      }
    },
    mounted () {
      Vue.prototype.$api.checkCredentials(this)
    }
  }
</script>

<style scoped>

</style>
